module.exports = __webpack_public_path__ + "img/IMG-20200227-WA0306.b122770b.jpg";